

















































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {RateRuleAmountFilter, RateRuleAmountModel} from '@/services/api/nswag/stapiclient_generated';
import {UserStore} from '@/store/user-module';
import {stRateRuleApi} from '@/services/st-api';
import StCurrencyInput from '@/components/basic/StCurrencyInput.vue';

@Component({
  components: {
    StCurrencyInput
  },
})
export default class TimeEntryRateInput extends Vue {
  @Prop() value!: boolean;
  @Prop() timeEntryRateAmount!: number;
  @Prop() rateRuleAmountFilter!: RateRuleAmountFilter;

  rateRuleAmountModel: RateRuleAmountModel = RateRuleAmountModel.fromJS({});
  initialRateRuleAmountChanged: boolean = false;
  initialCalculatedRateAmount: number = 0;
  watcher: any;
  loading:boolean = true;
  rateAmount = 0;

  async mounted(){
    this.initialCalculatedRateAmount = await this.getCalculatedRateRuleAmount();

    if(this.timeEntryRateAmount != null && this.timeEntryRateAmount != this.initialCalculatedRateAmount){
      this.initialRateRuleAmountChanged = true;
    }else{
      this.rateAmount = this.initialCalculatedRateAmount;
    }

    this.watcher = this.$watch('rateRuleAmountFilter',async ()=>{
      this.initialRateRuleAmountChanged=false;
      this.rateAmount = await this.getCalculatedRateRuleAmount();
    });
  }

  get useRateRules() {
    return UserStore.userSettings.useRateRules;
  }

  beforeDestroy(){
    this.watcher();
  }

  overwriteWithNewRateAmount(){
    this.initialRateRuleAmountChanged=false;
    this.rateAmount = this.initialCalculatedRateAmount;
    this.$emit('input', true);
  }

  async getCalculatedRateRuleAmount(){
    try {
      this.loading = true;
      if (this.useRateRules) {
        return await stRateRuleApi.getRateRuleAmount(this.rateRuleAmountFilter);
      } else {
        this.rateRuleAmountModel = await stRateRuleApi.getCustomerProjectRateRuleAmount(this.rateRuleAmountFilter);
        return this.rateRuleAmountModel.amount ?? 0;
      }
    } finally {
      this.loading = false;
    }
  }

}
